import { useState, useEffect } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { GetHeaders } from '../../Components/Admin/Functions/FetchHeaders.js';
import { FilterOrigins } from '../../Components/Public/Filters/FilterOrigins.js';
import { GetDescription } from '../../Components/Public/Functions/GetDescription.js';
import { ScrollTop } from '../../Components/Public/Functions/ScrollTop.js';
/* document */
import { Navigation } from '../../Components/Public/Document/Navigation.js';
import { Header } from '../../Components/Public/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { BreadCrumb } from '../../Components/Public/Document/Breadcrumb.js';
import { BlockLegend } from '../../Components/Public/Blocks/BlockLegend.js';
import { BlockLogoCharacters } from '../../Components/Public/Logos/BlockLogoCharacters.js';
import { BlockTitleDate1Link0 } from '../../Components/Public/Blocks/BlockTitleDate1Link0.js';
import { BlockOutlink } from '../../Components/Public/Blocks/BlockOutlink.js';
import { BackTop } from '../../Components/Public/Document/BackTop.js';

export const Characters = (props) => {
    const { navParks } = props;
    const backend = HostBackend();
    const guest = sessionStorage.getItem('guest');
    const [characters, setCharacters] = useState([]);
    const [body, setBody] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const charactersDatas = await fetch(`${backend}/characters`, GetHeaders(guest));
            const characters = await charactersDatas.json();
            setCharacters(characters);
            const bodyDatas = await fetch(`${backend}/characters/body`, GetHeaders(guest));
            const body = await bodyDatas.json();
            setBody(body);
        };
        fetchData();
        ScrollTop();
    }, [backend, guest]);
    const origins = FilterOrigins('characters', characters);
    const title_list = `${characters.length} personnages - ${origins.length} origins`;
    const items = GetDescription('characters', { body: body, characters: characters });
    return (
        <div className="origins">
            <Navigation navParks={navParks} />
            <Header />
            <BreadCrumb label="characters" />
            <section className="infos">
                <div className="characters">
                    <div className="list">
                        <div className="title-list">{title_list}</div>
                        <BlockLegend parks={navParks} />
                        {characters.map((item, i) => {
                            return (
                                <BlockLogoCharacters label="characters" item={item} key={i} />
                            )
                        })}
                    </div>
                </div>
                <div className="description">
                    <BlockTitleDate1Link0 label="characters" items={items} />
                    <p>{items.description}</p>
                    <BlockOutlink items={items} />
                </div>
            </section>
            <BackTop />
            <Footer />
        </div>
    )
}
